import { render, staticRenderFns } from "./ColumnTablero.vue?vue&type=template&id=76789d53&scoped=true&"
import script from "./ColumnTablero.vue?vue&type=script&lang=js&"
export * from "./ColumnTablero.vue?vue&type=script&lang=js&"
import style0 from "./ColumnTablero.vue?vue&type=style&index=0&id=76789d53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76789d53",
  null
  
)

export default component.exports